<!-- Layout -->
<template>
<div>
    <el-container>
        <el-header style="height:60px">
            <Header></Header>
        </el-header>
        <el-main>
            <Content></Content>
        </el-main>
        <!-- <el-footer>
            <Footer></Footer>
        </el-footer> -->
    </el-container>
</div>
</template>

<script>
import Header from '@/components/Header.vue'
import Content from '@/components/Content.vue'
import Footer from  '@/components/Footer.vue'
export default {
    name:'layout',
    components:{
        Header,
        Content,
        Footer
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang='scss' scoped>
.el-header{
    padding: 0 ;
}
.el-main{
    padding: 0;
}
.el-footer{
    padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/layout.vue